import axiosInstance from "./axiosConfig";

export const getUser = (email) => {
    let data = JSON.stringify({ "user_email": email });

    let config = {
        method: 'post',
        url: '/accounts/get_user/',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    const res = axiosInstance(config)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            console.log("error in getUser", error);
            return null;
        });

    return res;
}

const isValidURL = (string) => {
    var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null)
};

export const updateUser = (img, username, email) => {

    let data;

    if (isValidURL(img)) {
        data = JSON.stringify({
            "user_name": username,
        });
    } else {
        data = JSON.stringify({
            "user_name": username,
            "user_profile_pic_base64": img
        });
    }

    // let data = JSON.stringify({
    //     "user_name": username,
    //     "user_profile_pic_base64": img
    // });

    let config = {
        method: 'put',
        url: `/accounts/update_user/${email}/`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    let res = axiosInstance(config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("error in update user: ", error);
            return null;
        });

    return res;
}

export const addUser = (username, email, cognitoSub) => {
    let data = JSON.stringify({
        "user_name": username,
        "user_email": email,
        "role": "Manufacturer",
        "cognito_sub": cognitoSub,
        "user_profile_pic_base64": null
    });

    let config = {
        method: 'post',
        url: '/accounts/save_user/',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    const res = axiosInstance(config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("error in add user: ", error);
            return null;
        });

    return res;
}